<div class="row sub-title" (click)="open ? open = false : open = true">
    <div class="col-12">
        <img src="/assets/images/icons/add.svg" *ngIf="!open" />
        <img src="/assets/images/icons/minus.svg" *ngIf="open" />
        <span class="font-mont-semi-bold">APPLICATION HISTORY</span>
    </div>
</div>
<div class="row container" [ngClass]="{ 'open': open }">
    <div class="col-12">
        <table>
            <thead>
                <tr>
                    <th class="font-mont-semi-bold text-center">Action</th>
                    <th class="font-mont-semi-bold text-center">Date (Eastern Time)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let historyLine of history">
                    <td class="text-center">{{historyLine.action}}</td>
                    <td class="text-center">{{historyLine.timestamp}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>